import { Component, Input } from '@angular/core';
import { TunnelDisplayedProduct } from '../../models/tunnel-displayed-product';

/** Grille de résultats de la recherche produit. */
@Component({
  selector: 'ng-casto-tunnel-product-list',
  templateUrl: './tunnel-product-list.component.html',
  styleUrls: ['./tunnel-product-list.component.scss'],
})
export class TunnelProductListComponent {
  @Input() products: TunnelDisplayedProduct[] = [];
  @Input() loading: boolean = false;
  @Input() emptyMessageKey: string;

  /** Cartes de chargement affichées le temps de la recherche. */
  protected readonly skeletons = Array.from({ length: 10 });
}
